<template>
    <div id="load-wrapper">
        <div class="text-center loaderIcon"><img src="/assets/logo.png"/></div>
        <div class="text-center loaderSpinner">
            <v-progress-circular 
            :size="50"
            :width="3"
            indeterminate
            color="blue-grey darken-1"
            ></v-progress-circular>
        </div>
        <div class="text-center loaderMessage"></div>
        <div class="loaderInfo">{{loadingInfo}}</div>
        <div class="loaderVersion">Routes to Schools {{appVersion}}</div>
    </div> 
</template>

<script>
export default {
props: {
    appVersion: { type: String, required: true},    
    loadingInfo: { type: String, default: "..." },    
  }
}
</script>

<style lang="scss">

.center-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

#load-wrapper {
  z-index:998;
  position: fixed;
  background: #282c34;
  color:#adb7ce;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity:1;
  transition:visibility 1.2s linear,opacity 1s linear;
  /*padding: 20px;*/
}	
.loaderIcon{
  margin-top: 10rem;
}
.loaderSpinner{
  position: relative;
  margin-top: 4rem;
}

.loaderVersion{
  font-size: 0.8rem;
  position: fixed;
  bottom:1.5rem;
  right:1.5rem;
  color:#7d7f85;
}
.loaderInfo{
  font-size: 0.8rem;
  position: fixed;
  bottom:1.5rem;
  left:1.5rem;
  color:#7d7f85;
}
</style>